import { AxiosInstance } from "axios";

import { IBookmarkAsset } from '@mais-retorno-front/models/bookmark-asset.model';
import { ICatchIssueUseCase } from '../catch-issue.usecase';

interface IHandleDTO {
  token: string,
  asset: {
    asset_type: string;
    identifier: string;
  }
}

interface IHandleResponse {
  data: IBookmarkAsset;
  error: boolean;
  message: string;
}

interface ICreateBookmarkAssetUseCase {
  handle(params: IHandleDTO): Promise<IHandleResponse>;
}

export class CreateBookmarkAssetUseCase implements ICreateBookmarkAssetUseCase {
  constructor(
    private readonly url: string,
    private readonly http: AxiosInstance,
    private readonly catchIssueUseCase: ICatchIssueUseCase
  ) {}

  async handle({
    token,
    asset
  }: IHandleDTO): Promise<IHandleResponse> {
    try {
      const { data } = await this.http.post<IBookmarkAsset>(this.url, asset);

      return {
        data,
        error: false,
        message: 'Fundo favoritado com sucesso'
      };

    } catch (error) {
      this.catchIssueUseCase.handle({
        error,
        errorName: 'CreateBookmarkAssetUseCase',
        extras: {
          token,
          asset
        }
      });

      return {
        data: {} as IBookmarkAsset,
        error: true,
        message: 'Não foi possível favoritar o fundo, tente novamente mais tarde'
      }
    }
  }
}